// SDK lifecycle events include URLs even when custom events omit search text.
// Strip teacher-page query strings from all URL properties, including nested
// $set/$set_once initial-referrer properties, before the SDK sends an event.
export function sanitizeTeacherUrls(event) {
  function clean(value) {
    if (typeof value === 'string' && /^https?:\/\//i.test(value)) {
      try {
        const url = new URL(value);
        if (['/teachers', '/teachers.html'].includes(url.pathname) || url.pathname.startsWith('/teachers/')) {
          const level = url.searchParams.get('level');
          url.search = '';
          url.hash = '';
          if (['/teachers/lesson', '/teachers/lesson.html'].includes(url.pathname) && /^(jungle|temple|aegean|winter)-\d+$/.test(level || '')) url.searchParams.set('level', level);
          return url.href;
        }
      } catch { /* Leave non-URL values alone. */ }
    } else if (Array.isArray(value)) return value.map(clean);
    else if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, clean(item)]));
    return value;
  }
  if (event?.properties) event.properties = clean(event.properties);
  return event;
}
